import React from 'react';
import PropTypes from 'prop-types';

export default function SpacerComponent({ component, style }) {
	let height;

	let spaceType = 'medium';
	switch (component.margin) {
		case 'margin-1':
			spaceType = 'vsmall';
			break;
		case 'margin-20':
			spaceType = 'small';
			break;
		case 'margin-75':
			spaceType = 'large';
			break;
		case 'margin-100':
			spaceType = 'vlarge';
			break;
	}

	if (style?.spacer) {
		const {
			spacer_vsmall_height,
			spacer_small_height,
			spacer_medium_height,
			spacer_large_height,
			spacer_vlarge_height,
		} = style?.spacer;
		switch (spaceType) {
			case 'vsmall':
				height = `${spacer_vsmall_height}px`;
				break;
			case 'small':
				height = `${spacer_small_height}px`;
				break;
			case 'medium':
				height = `${spacer_medium_height}px`;
				break;
			case 'large':
				height = `${spacer_large_height}px`;
				break;
			case 'vlarge':
				height = `${spacer_vlarge_height}px`;
				break;
		}
	}

	return (
		<div style={{ height }}>
			<br />
		</div>
	);
}

SpacerComponent.propTypes = {
	component: PropTypes.object.isRequired,
	style: PropTypes.object,
	stylesMap: PropTypes.any,
};
